import {gql} from 'apollo-angular';

export const listNetworksQuery = gql`
    query listNetworks($userId: ID!, $monetizationEngine: MediationEngine) {
        listNetworks(userId: $userId, monetizationEngine: $monetizationEngine) {
            id
            accountTypeName
            displayName
            shortName
        }

        listUserNetworkAccounts(userId: $userId, defaultAccountsOnly: true, monetizationEngine: $monetizationEngine) {
            id
            isDefault
            isUserAccount
            login
            networkId
            __typename
            permissions {
                canDelete
                canEdit
            }
        }
    }
`;
